module.exports = __webpack_public_path__ + "static/profile4-3075fb3eb2945e80f5fa3cae41fda12a.jpg";